module.exports = __webpack_public_path__ + "static/media/lily-carter-lesb.7c2af335.jpg";